import { Proposition } from './proposition';

export const PROPOSITIONS: Proposition[] = [
  {
    title: 'Husqvarna',
    icon: '',
    image: '',
    today: '',
    tomorrow: '',
    next: '',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/value-proposition/propositions/propositions.ts